import { useState, useEffect } from 'react'
import Typography from '@mui/material/Typography'
import uuid from 'uuid/v4'
import { PreviewValueGenerators } from './preview-generators'
import { t } from '@lingui/core/macro'

export const Preview = ({ pattern, colors }) => {
  const [urlParts, setUrlParts] = useState([])

  useEffect(() => {
    if (!pattern || !pattern.segments) {
      setUrlParts([])
    }

    function previewGenerator(element) {
      const valueGenerator =
        PreviewValueGenerators[element.segment_type] || PreviewValueGenerators.unknown
      const value = valueGenerator(element)
      return {
        key: uuid(),
        color: colors[element.segment_type],
        value,
      }
    }

    let parts = pattern.segments.map(previewGenerator)

    // add in delimiters
    if (parts.length && pattern.delimiter !== '') {
      parts = parts.reduce((memo, part) => {
        memo.push(part)
        memo.push({
          key: uuid(),
          value: pattern.delimiter,
        })
        return memo
      }, [])

      // trim off extra at the end
      parts.length -= 1
    }

    setUrlParts(parts)
  }, [pattern])

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        {t`Preview`}
      </Typography>
      {!pattern.segments.length ? (
        <span className="placeholder">{t`Add elements below to see a preview of your pattern`}</span>
      ) : (
        <span style={{ fontSize: 18, wordWrap: 'break-word' }}>
          {urlParts.map(part => (
            <span key={part.key} className="url-part" style={{ color: part.color }}>
              {part.value}
            </span>
          ))}
        </span>
      )}
    </div>
  )
}
